export default __webpack_public_path__ + "static/media/MX-Specs-Hero-Mobile.2c5b3491.jpg";